import { slugifyHeading } from './blogCategories';

export default function TableOfContents({ content }) {
  const headings = (content.match(/^##\s+.+$/gm) || []).map((h) => h.replace(/^##\s+/, ''));

  if (headings.length === 0) return null;

  return (
    <div className="rounded-2xl border border-border/50 bg-card p-6 sticky top-24">
      <h4 className="text-xs font-inter font-bold tracking-[0.2em] uppercase text-foreground mb-4">
        Table of Contents
      </h4>
      <nav className="space-y-2.5">
        {headings.map((h) => (
          <a
            key={h}
            href={`#${slugifyHeading(h)}`}
            className="block text-sm text-muted-foreground font-inter hover:text-primary transition-colors"
          >
            {h}
          </a>
        ))}
      </nav>
    </div>
  );
}